<template>
  <PopupBox
    :disable="disable"
    class="company-select"
    :popup-styles="{ top: 3 }"
    placement="bottom-start"
    @visibility-change="handlePopupVisibilityChange"
  >
    <template v-slot:trigger>
      <p
        :class="clsx(
          'company-select__trigger',
          {
            'company-select__trigger--active': hasActiveFilters,
            'company-select__trigger--disabled': disable
          }
        )"
      >
        Компанії{{ hasActiveFilters && getSelectedCompaniesCount > 0 ? `-${getSelectedCompaniesCount}` : '' }}
      </p>
    </template>

    <template>
      <div class="company-select__menu">
        <PopupMenuList
          :items="companies"
          :selected-item="selectedCompany"
          :checkbox-style="checkboxStyle"
        />
      </div>
    </template>
  </PopupBox>
</template>

<script>
import clsx from 'clsx';
import { PopupBox, PopupMenuList, popupToggle } from '@/shared/ui/popup';

export default {
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    companies: {
      type: Array,
      required: true,
    },
    selectedCompany: {
      type: Object,
      default: () => ({}),
    },
    checkboxStyle: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'styled'].includes(value),
    },
  },
  mixins: [popupToggle],
  components: { PopupBox, PopupMenuList },
  computed: {
    hasActiveFilters() {
      if (
        (Array.isArray(this.selectedCompany) && this.selectedCompany.length === 0) ||
        (!Array.isArray(this.selectedCompany) && !this.selectedCompany?.id)
      ) {
        return false;
      }

      return (Array.isArray(this.selectedCompany?.id) && this.selectedCompany?.id?.length > 0) ||
        (!Array.isArray(this.selectedCompany?.id) && !!this.selectedCompany?.id);
    },
    getSelectedCompaniesCount() {
      if (Array.isArray(this.selectedCompany?.id) && this.selectedCompany?.id?.length > 0) {
        return this.selectedCompany.id.length;
      }

      if (this.selectedCompany?.id) {
        return 1;
      }

      return 0;
    },
  },
  methods: { clsx },
};
</script>

<style scoped lang="scss">
.company-select {
  display: inline-block;
  margin-bottom: 16px;
}

.company-select__trigger {
  font-size: 16px;
  font-weight: 400;
  padding: 12px 16px;
  margin: 0;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;

  &--active {
    color: #fb923c;
    border-color: #fb923c;
  }

  &--disabled {
    cursor: not-allowed;
    color: #6b7280;
    background-color: #f3f4f6;
  }
}

.company-select__menu {
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
}

::v-deep .popup-menu-list {
  box-shadow: none;
}
</style>
